import React from 'react';
import { CONTACT_PHONE } from '../config';
import { formatShortDate, fmtDollars } from '../utils/pricing';
import { SendAdCard, RunScheduleTable } from './SendYourAd';

// Shown after an advertiser asks to be invoiced instead of paying through
// PayPal. Nothing has been charged, so this deliberately avoids the paid
// confirmation's "order is confirmed" / "Total Paid" wording, and puts paying
// the invoice first (Step 1) ahead of sending the ad (Step 2).
export default function InvoiceRequested({ orderData, form }) {
  const { pricing, runSchedule } = orderData;
  const firstDate = runSchedule?.[0];
  const lastDate  = runSchedule?.[runSchedule.length - 1];

  return (
    <div className="confirmation-container">
      <div className="confirmation-header">
        <a
          href="https://www.hendersonvillelightning.com"
          target="_blank"
          rel="noopener noreferrer"
          className="logo-link"
          title="Go to www.HendersonvilleLightning.com"
        >
          <img src="/logo.jpg.jpg" alt="Hendersonville Lightning" className="logo-img" />
        </a>
      </div>

      <div className="confirmation-card" style={{ textAlign: 'center' }}>
        <div className="check-circle invoice-circle" aria-hidden="true">&#9993;</div>
        <div className="confirmation-title">Invoice request received</div>
        <div className="confirmation-amount">{fmtDollars(pricing.total)}</div>
        <div className="unpaid-pill">Not paid yet</div>
        {firstDate && lastDate && (
          <p style={{ color: 'var(--charcoal-mid)', fontSize: '0.85rem', marginTop: 10 }}>
            {formatShortDate(firstDate)}{runSchedule.length > 1 && <> to {formatShortDate(lastDate)}</>}
            &nbsp;&middot;&nbsp;{runSchedule.length} issue{runSchedule.length !== 1 ? 's' : ''}
          </p>
        )}
      </div>

      {/* Step 1: payment comes first */}
      <div className="send-card pay-card">
        <div className="send-eyebrow">Step 1</div>
        <div className="send-title">Pay your invoice</div>
        <div className="pay-box">
          <div className="pay-amount">{fmtDollars(pricing.total)}</div>
          <div>
            <div className="pay-lead">Watch for a PayPal invoice at</div>
            <div className="pay-email">{form.contact.email}</div>
            <div className="pay-sub">You can pay it by card. Nothing has been charged yet.</div>
          </div>
        </div>
        <p className="send-fine">
          Please pay it as soon as it arrives. Your spot is pending until payment comes in.
          Don&rsquo;t see it? Check your spam folder, or call{' '}
          <a href={CONTACT_PHONE.tel}>{CONTACT_PHONE.display}</a>.
        </p>
      </div>

      {/* Step 2: the same ad card as a paid order */}
      <SendAdCard form={form} runSchedule={runSchedule} eyebrow="Step 2" className="send-card-secondary" />

      <div className="confirmation-card">
        <div className="send-heading" style={{ marginBottom: 14 }}>Your Run Schedule</div>

        <RunScheduleTable runSchedule={runSchedule} />

        <hr className="divider" />

        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 800, fontSize: '1rem' }}>
          <span>Total Due</span>
          <span>{fmtDollars(pricing.total)}</span>
        </div>
        <div style={{ color: 'var(--red)', fontSize: '0.8rem', textAlign: 'right', marginTop: 4, fontWeight: 600 }}>
          Not paid yet. Your PayPal invoice is on its way.
        </div>

        <p className="send-questions">
          Questions? Call <a href={CONTACT_PHONE.tel}>{CONTACT_PHONE.display}</a> or email{' '}
          <a href="mailto:ads@hendersonvillelightning.com">ads@hendersonvillelightning.com</a>.
        </p>
      </div>
    </div>
  );
}
